// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfo_a"};